<template>
  <div class="mHome">
    <mNav :msg="msg" :IsHome="false"></mNav>
    <div class="banner">
      <van-swipe :autoplay="2000">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>

    
    <div class="tree_box">
      <div class="searchMon">
          <el-date-picker
            v-model="monthVal"
            type="month"
            @change="changeMonth"
            value-format="yyyy年MM月"
            placeholder="请选择开始月份">
          </el-date-picker>
      </div>
      <div class="listWrapper">
        <el-timeline>
          <el-timeline-item
            class="listbox"
            placement="top"
            v-for="(i, index) in sportListNew"
            :key="index"
            :timestamp="i.BeginDate"
          >
            <!-- <el-card
              v-lazy="{ getData: getData, id: i.id, throttle: throttle }"
              class="animate__animated animate__fadeInRightBig"
            > -->
            <el-card
              v-lazy="{ getData: getData, id: i.SportCode, throttle: throttle }"
              :class="`a ${i.SportCode}`"
              @click.native="handleGame(i)"
            >
              <div>
                <h3>{{ i.SportName }}</h3>
                <p><van-icon name="location-o" />{{i.SportVenue}}</p>
                <p><van-icon name="clock-o" />{{ i.BeginDate +'-'+ i.EndDate}}</p>
              </div>
              <div class="yuandian">
                <el-tag size="mini"
                :color="i.StatusCode < 50 ? '#3277bc' : ''"
                 effect="dark" :type="i.StatusCode < 50 ? '' : i.StatusCode == 50 ? 'success' : i.StatusCode > 50 ? 'info' : ''">{{ i.StatusName }}</el-tag>
              </div>
              <!-- <div class="yuandian" :style="{'background':'rgb(4,201,125)'}"></div>
              <div class="yuandian" :style="{'background':'rgb(4,201,125)'}"></div> -->
            </el-card>
          </el-timeline-item>
          <!-- <el-timeline-item timestamp="2018/4/3" placement="top">
                    <el-card class="animate__animated animate__fadeInRightBig">
                        <h4>更新 Github 模板</h4>
                        <p>王小虎 提交于 2018/4/3 20:46</p>
                        <h4>更新 Github 模板</h4>
                        <p>王小虎 提交于 2018/4/2 20:46</p>
                        <h4>更新 Github 模板</h4>
                        <p>王小虎 提交于 2018/4/2 20:46</p>
                    </el-card>
                </el-timeline-item> -->
        </el-timeline>
        <van-empty v-if="sportListNew.length == 0" description="没有数据啦。" />
      </div>
    </div>
  </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import sportList from '@/assets/common/SportList.json';
import axios from 'axios';
import http from '@/assets/js/http.js';
// import lazy from'@/assets/js/element-lazy.js';
import Vue from "vue";
import { Lazyload,Toast,Dialog } from "vant";
Vue.use(Lazyload,Toast);
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
export default {
  name: "mHome",
  components: {
    mNav,
  },
  data() {
    return {
      msg: "羽毛球成绩网站",
      // images: [
      //   "https://img01.yzcdn.cn/vant/apple-1.jpg",
      //   "https://img01.yzcdn.cn/vant/apple-2.jpg",
      //   "https://img01.yzcdn.cn/vant/apple-3.jpg",
      //   "https://img01.yzcdn.cn/vant/apple-4.jpg",
      // ],
      images: [
      // require("@/assets/img/banner2.jpg"),
          require("@/assets/img/banner1.png"),
          require("@/assets/img/banner2.png"),
          require("@/assets/img/banner7.jpg"),
          // require("@/assets/img/banner0.png"),
      ],
      monthVal: '',
      sportList: {},
      currentPage: 0, // 当前页面的索引值
      pageSize: 3, // 每次加载的数据数量
      listEmpty: [],
      listAllarr: [],
      num: 2,
      dom: null,
      sportListNew:[],
      // activities: [
      //   {
      //     id: 1,
      //     content: "支持使用图标",
      //     timestamp: "2018-04-12 20:46",
      //     size: "large",
      //     time: "2028-14-03",
      //     // type: 'primary',
      //   },
      //   {
      //     id: 2,
      //     content: "支持自定义颜色",
      //     timestamp: "2018-04-03 20:46",
      //     time: "23028-14-03",
      //     // color: 'hsl '
      //   },
      //   {
      //     id: 3,
      //     content: "支持自定义尺寸",
      //     timestamp: "2018-04-03 20:46",
      //     time: "4028-14-03",
      //     size: "large",
      //   },
      //   {
      //     id: 4,
      //     content: "默认样式的节点",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      //   {
      //     id: 5,
      //     content: "默式的节点1",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2018-04-03 20:46",
      //   },
      //   {
      //     id: 6,
      //     content: "式的节点2",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2018-04-11",
      //   },
      //   {
      //     id: 7,
      //     content: "式的节点3",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      //   {
      //     id: 8,
      //     content: "式的节点33333",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      //   {
      //     id: 9,
      //     content: "式的节4444点3",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      //   {
      //     id: 10,
      //     content: "式3123123的节点3",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      //   {
      //     id: 11,
      //     content: "式的节4444点3",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      //   {
      //     id: 12,
      //     content: "式3123123的节点3",
      //     timestamp: "2018-04-03 20:46",
      //     time: "2028-14-03",
      //   },
      // ],
    };
  },
  mounted() {
    // console.log(this.monthVal);
    // console.log(this.sportList)
    // this.sportListNew = this.sportList.JsonData;
    // window.addEventListener('scroll', this.handleScroll);
    // console.log(this.activities.length);
    // this.loadMoreData();
    // console.log(document.querySelector('.tree_box').scrollHeight)
    // setTimeout(() => {
    //     this.ladzyloding()
    // }, 1500);
    // http://123.57.154.187/InformationPublish/WebAPIServerRelease/Sports/TTE
    // encodeURI('D:/InformationPublish/WebAPIServerRelease/Sports/TTE/SportList.json')
    // ../../assets/common/SportList.json   /Sports/TTE/SportList.json
    http.GetFile('/Sports/BDM/SportList.json?v='+Math.random()).then(res=>{//获取赛事列表地址
        console.log(res)
        this.sportListNew = res.JsonData;
        this.sportList = res;
    })
    
    // var xhr = new XMLHttpRequest();
    // xhr.open('POST', 'http://192.168.1.189:8131/ResultList.json', true);
    // console.log(moke)
    // http.GetFile('D:/InformationPublish/WebAPIServerRelease/Sports/TTE/SportList.json').then(res=>{//操作日志添加接口
    //     console.log(res)
    // })
      
  },
  methods: {
    handleGame(item){//点击赛事列表逻辑
      console.log(item);
      
      if(item.StatusCode < 50){
        Toast({
            message:item.StatusName,
            duration:1000
        });
      }else{
        // this.$router.push('/Live');
        // 生成随机数
        let randomNum = Math.random(); // 这里的范围根据需求进行调整
        this.$router.push({
              path: '/GameResult', 
              query: { v: randomNum }
        });
        sessionStorage.setItem('language',item.LanguageCode)
        sessionStorage.setItem('SportCode',item.SportCode)
        sessionStorage.setItem('SportName',item.SportName)
      }
    },
    changeMonth(){//月份筛选
      this.sportListNew = this.sportList.JsonData;
      this.monthVal== null ?this.monthVal='': this.monthVal;
      // console.log(this.monthVal);
      let newArr = [];
      let monthVal = this.monthVal

      if(monthVal !='' ){
        newArr = this.sportListNew.filter(function(el){
          return el.BeginDate.includes(monthVal)
        })
        console.log(newArr);
        this.sportListNew = newArr;
      }else{
        // console.log()
        this.sportListNew = this.sportList.JsonData;
      }
      // this.activities.forEach(el => {
      //   // console.log(el);
      //   if(el.BeginDate.indexOf(this.monthVal)){
      //     console.log(el)
      //   }
      // });
    },


    /**
     * 懒加载逻辑-完成
     * */ 
    throttle(fn, wait) {
      // console.log(fn);
      // console.log(wait);
      //闭包节流
      let timer = "";
      return function (...args) {
        if (timer) return;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(this, args);
        }, wait);
      };
    },
    getData(id, lazyLoadObser, lazyImage) {
      // console.log("加载", id);
      // console.log("2", lazyLoadObser);
      // console.log("3载", lazyImage);
      //解绑监听事件
      // console.log(document.getElementsByClassName(id))
      lazyLoadObser.unobserve(lazyImage);
      document.getElementsByClassName(id)[0].style = "transform:translate(0px)";
      //   this.$set(this.activities[id], ".listbox", "b");
    },
    /**
     * 懒加载逻辑结束
     * */


    /**
     * 懒加载逻辑-写一半方法
     * */
    loadMoreData() {
      this.listAllarr = this.activities;
      this.num = 2;
      this.listEmpty = [];

      if (this.listAllarr.length > 2) {
        for (let i = 0; i < 3; i++) {
          this.listEmpty[i] = this.listAllarr[i];
        }
      } else {
        this.listEmpty = this.listAllarr;
      }
    },
    ladzyloding() {
      let dom = document.querySelector(".listWrapper");

      console.log(dom.scrollHeight);
      console.log(dom.scrollTop);
      console.log(dom.clientHeight);
      window.addEventListener("scroll", (v) => {
        var pagescrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(pagescrollTop)
        const scrollDistance =
          dom.scrollHeight - dom.scrollTop - dom.clientHeight;
        console.log("鼠标移动:", scrollDistance);
        if (scrollDistance <= 1) {
          //0等于到底了
          //一条一条加载数据，直至遍历到最后一条
          while (this.num < this.listAllarr.length) {
            this.listEmpty[this.num] = this.listAllarr[this.num];
            // this.listEmpty.push(this.listAllarr[this.num])
            console.log(this.listEmpty);
            this.$forceUpdate();
            this.num++;
            // console.log(this.num)
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  height: 100vh;
  position: relative;
}
.a {
  transform: translateX(260px);
}
.banner {
  // width: 100%;
  height: 3rem;
  padding: 0.1rem;
  overflow: hidden;
  text-align: center;
  img {
    width: 100%;
    height: 3rem;
  }
}
.tree_box {
  // height: auto;
  // height: 100vh;
  padding: 0.3rem;
  background: #3277bc;
  margin-top: 0.2rem;
  // overflow: hidden;
  overflow-x: hidden;
  .searchMon{
    // width: 100%;
    // height: auto;
    font-size: 0.24rem;
    padding: 0.2rem;
  }
  .listWrapper {
    // height: auto;
    min-height: 10rem;
    position: relative;
    // overflow: hidden;
  }
  .listbox {
    // color: white;
    position: relative;
    transition: all ease 3s;
    // visibility: hidden;
  }
}
.yuandian{
  // width: 1rem;
  // height: 0.3rem;
  // border-radius: 0.1rem;
  position: absolute;
  top: 0%;
  right: 0%;
  font-size: 0.2rem;
  background: #c1bebe;
  text-align: center;
  // color: white;
}

</style>